export const path = {
    HOME: '/',
    HOMEPAGE:'/home',
    LOGIN: '/login',
    LOG_OUT: '/logout',
    SYSTEM: '/system',
    DETAIL_DOCTOR:'/detail-doctor/:id',
    DETAIL_SPECIALTY:'/detail-specialty/:id',
    DETAIL_CLINIC:'/detail-clinic/:id',

    VERIFY_EMAIL_BOOKING:'/verify-booking'

};

export const LANGUAGE = {
    VI: 'vi',
    EN: 'en'
};
 
export const CRUD_ACTIONS = {
    CREATE: "CREATE",
    EDIT: "EDIT",
    DELETE: "DELETE",
    READ: "READ",
};

export const dateFormat = {
    SEND_TO_SERVER: 'DD/MM/YYYY'
};

export const YesNoObj = {
    YES: 'Y',
    NO: 'N'
}
export const USER_ROLE ={
    ADMIN: 'R1',
    DOCTOR: 'R2',
    PATIENT: 'R3'
}